import React from 'react';
import './Terms.css';

const Terms = () => {
	return (
		<div className="terms-container">
			<div className="terms-content">
				<h1>이용약관</h1>
				
				<section className="terms-section">
					<h2>제1조 (목적)</h2>
					<p>
						이 약관은 wearToday(이하 "회사")가 운영하는 온라인 쇼핑몰에서 제공하는 
						인터넷 관련 서비스(이하 "서비스")를 이용함에 있어 회사와 이용자의 권리, 
						의무 및 책임사항을 규정함을 목적으로 합니다.
					</p>
				</section>

				<section className="terms-section">
					<h2>제2조 (정의)</h2>
					<ol>
						<li>"회사"란 wearToday를 운영하는 사업자를 말합니다.</li>
						<li>"회원"이란 회사에 개인정보를 제공하여 회원등록을 한 자로서, 회사의 정보를 지속적으로 제공받으며, 회사가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.</li>
						<li>"비회원"이란 회원에 가입하지 않고 회사가 제공하는 서비스를 이용하는 자를 말합니다.</li>
						<li>"구매대행"이란 회사가 이용자의 주문을 받아 해외에서 상품을 구매하여 국내로 배송하는 서비스를 말합니다.</li>
					</ol>
				</section>

				<section className="terms-section">
					<h2>제3조 (약관의 명시와 개정)</h2>
					<ol>
						<li>회사는 이 약관의 내용과 상호, 영업소 소재지, 대표자의 성명, 사업자등록번호, 연락처 등을 이용자가 알 수 있도록 초기 서비스화면에 게시합니다.</li>
						<li>회사는 약관의 규제에 관한 법률, 전자거래기본법, 전자서명법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 소비자보호법 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.</li>
						<li>회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 서비스 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다.</li>
					</ol>
				</section>

				<section className="terms-section">
					<h2>제4조 (서비스의 제공 및 변경)</h2>
					<ol>
						<li>회사는 다음과 같은 업무를 수행합니다:
							<ul>
								<li>해외 상품 구매대행 서비스</li>
								<li>상품 정보 제공</li>
								<li>배송 및 물류 서비스</li>
								<li>기타 회사가 정하는 업무</li>
							</ul>
						</li>
						<li>회사는 상품의 품절 또는 기술적 사양의 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 상품의 내용을 변경할 수 있습니다.</li>
					</ol>
				</section>

				<section className="terms-section">
					<h2>제5조 (회원가입)</h2>
					<ol>
						<li>이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.</li>
						<li>회사는 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다:
							<ul>
								<li>가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우</li>
								<li>등록 내용에 허위, 기재누락, 오기가 있는 경우</li>
								<li>기타 회원으로 등록하는 것이 회사의 기술상 현저히 지장이 있다고 판단되는 경우</li>
							</ul>
						</li>
					</ol>
				</section>

				<section className="terms-section">
					<h2>제6조 (구매신청 및 개인정보 제공 동의 등)</h2>
					<ol>
						<li>회사 이용자는 회사 상에서 다음 또는 이와 유사한 방법에 의하여 구매를 신청하며, 회사는 이용자가 구매신청을 함에 있어서 다음의 각 내용을 알기 쉽게 제공하여야 합니다:
							<ul>
								<li>상품의 검색 및 선택</li>
								<li>받는 사람의 성명, 주소, 전화번호, 전자우편주소 등의 입력</li>
								<li>약관내용, 청약철회권이 제한되는 서비스, 배송료 등의 비용부담과 관련한 내용에 대한 확인</li>
								<li>이 약관에 동의하고 위 사항을 확인하거나 거부하는 표시</li>
								<li>상품의 구매신청 및 이에 관한 확인 또는 회사의 확인에 대한 동의</li>
								<li>결제방법의 선택</li>
							</ul>
						</li>
					</ol>
				</section>

				<section className="terms-section">
					<h2>제7조 (배송 및 관세)</h2>
					<ol>
						<li>회사는 구매대행 서비스의 특성상 배송 기간은 주문 후 7~14일이 소요되며, 현지 사정에 따라 변동될 수 있습니다.</li>
						<li>관세법에 따라 일정 금액 초과 시 관세가 부과되며, 이는 구매자가 부담합니다:
							<ul>
								<li>미국: $200 초과 시</li>
								<li>기타 국가: $150 초과 시</li>
							</ul>
						</li>
						<li>배송비는 무료이며, 도서산간 지역 추가 비용은 없습니다.</li>
					</ol>
				</section>

				<section className="terms-section">
					<h2>제8조 (교환 및 반품)</h2>
					<ol>
						<li>교환 및 반품은 제품 수령 후 7일 이내에 신청 가능합니다.</li>
						<li>교환/반품 비용:
							<ul>
								<li>단순 변심: 왕복 배송비 고객 부담 (약 30,000원)</li>
								<li>상품 하자: 무료 교환/반품</li>
							</ul>
						</li>
						<li>다음의 경우 교환 및 반품이 불가능합니다:
							<ul>
								<li>착용 또는 세탁한 상품</li>
								<li>택(TAG) 제거 또는 훼손된 상품</li>
								<li>구매자의 단순 변심 (해외 구매대행 특성)</li>
							</ul>
						</li>
					</ol>
				</section>

				<section className="terms-section">
					<h2>제9조 (개인정보보호)</h2>
					<ol>
						<li>회사는 이용자의 정보수집시 구매계약 이행에 필요한 최소한의 정보를 수집합니다.</li>
						<li>회사는 이용자의 개인정보를 수집·이용하는 때에는 당해 이용자에게 그 목적을 고지하고 동의를 받습니다.</li>
						<li>회사는 수집된 개인정보를 목적외의 용도로 이용할 수 없으며, 새로운 이용목적이 발생한 경우 또는 제3자에게 제공하는 경우에는 이용·제공단계에서 당해 이용자에게 그 목적을 고지하고 동의를 받습니다.</li>
					</ol>
				</section>

				<section className="terms-section">
					<h2>제10조 (회사의 의무)</h2>
					<ol>
						<li>회사는 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적으로 상품을 제공하는데 최선을 다하여야 합니다.</li>
						<li>회사는 이용자가 안전하게 인터넷 서비스를 이용할 수 있도록 이용자의 개인정보 보호를 위한 보안 시스템을 갖추어야 합니다.</li>
					</ol>
				</section>

				<section className="terms-section">
					<h2>제11조 (회원의 의무)</h2>
					<ol>
						<li>회원은 다음 행위를 하여서는 안 됩니다:
							<ul>
								<li>신청 또는 변경시 허위 내용의 등록</li>
								<li>타인의 정보 도용</li>
								<li>회사에 게시된 정보의 변경</li>
								<li>회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</li>
								<li>회사 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
								<li>회사 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
							</ul>
						</li>
					</ol>
				</section>

				<section className="terms-section">
					<h2>부칙</h2>
					<p>이 약관은 2025년 1월 1일부터 적용됩니다.</p>
				</section>

				<div className="terms-footer">
					<p>최종 수정일: 2025년 1월 1일</p>
					<button onClick={() => window.history.back()} className="btn-back">
						← 돌아가기
					</button>
				</div>
			</div>
		</div>
	);
};

export default Terms;